var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.82031 1.65525C5.59958 1.6587 5.38924 1.74959 5.23545 1.90796C5.08165 2.06633 4.99698 2.27924 5 2.49998V3.33331H4.16667C3.25578 3.33331 2.5 4.08909 2.5 4.99998V16.6666C2.5 17.5775 3.25578 18.3333 4.16667 18.3333H15.8333C16.7442 18.3333 17.5 17.5775 17.5 16.6666V4.99998C17.5 4.08909 16.7442 3.33331 15.8333 3.33331H15V2.49998C15.0015 2.38849 14.9807 2.27782 14.9387 2.17454C14.8966 2.07126 14.8343 1.97745 14.7554 1.89869C14.6765 1.81992 14.5826 1.75779 14.4792 1.71597C14.3758 1.67416 14.2651 1.65351 14.1536 1.65525C13.9329 1.6587 13.7226 1.74959 13.5688 1.90796C13.415 2.06633 13.3303 2.27924 13.3333 2.49998V3.33331H6.66667V2.49998C6.66819 2.38849 6.64733 2.27782 6.60532 2.17454C6.56331 2.07126 6.50099 1.97745 6.42208 1.89869C6.34316 1.81992 6.24923 1.75779 6.14587 1.71597C6.0425 1.67416 5.9318 1.65351 5.82031 1.65525ZM4.16667 7.49998H15.8333V16.6666H4.16667V7.49998ZM10.8333 10.8333C10.3733 10.8333 10 11.2066 10 11.6666V14.1666C10 14.6266 10.3733 15 10.8333 15H13.3333C13.7933 15 14.1667 14.6266 14.1667 14.1666V11.6666C14.1667 11.2066 13.7933 10.8333 13.3333 10.8333H10.8333Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.1872b419a92bccf063d9dee49ef602bd.svg";
export { ForwardRef as ReactComponent };